import React, {useState, useEffect} from 'react'
import { useSelector } from 'react-redux'
import Select, { components } from 'react-select'
import isMobile from 'ismobilejs'

const CustomSelect = ({options, classes, onChange, onChangeMobile, hasReset = false, type = false, dynamicValue = null}) => {
  let [isMobileSelect, setIsMobileSelect] = useState(false)

  const projectsStatus = useSelector(state => state.projectsStatus)
  const projectsRegion = useSelector(state => state.projectsRegion)

  const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <svg className={`react-select__icon icon-night ${props.selectProps.menuIsOpen && 'is-open'}`} width="32" height="32" viewBox="0 0 48 48">
            <path d="M18.395 12.39a1.363 1.363 0 0 1 1.782-.11l.128.11 10.8 10.667c.486.48.524 1.237.112 1.76l-.112.126-10.8 10.666c-.528.521-1.382.521-1.91 0a1.321 1.321 0 0 1-.112-1.76l.112-.125L28.24 24l-9.845-9.724a1.321 1.321 0 0 1-.112-1.76l.112-.125z" fillRule="nonzero"/>
          </svg>
        </components.DropdownIndicator>
        )
    )
  }

  useEffect(() => {
    if(typeof window !== 'undefined') {
      setIsMobileSelect(isMobile(window.navigator).any) 
    }
  }, [])

  const renderCustomSelect = () => {
    let value, defaultValue

    if (hasReset) {
      const stateVariable = (type === 'status' ? projectsStatus : projectsRegion)
      value = (stateVariable === null) ? options[0] : stateVariable
    } else {
      defaultValue = options[0]
    }
    
    return(
      <>
      { hasReset || dynamicValue !== null  ?
        <Select 
          components={{ DropdownIndicator }}
          options={options}
          onChange={onChange}
          value={dynamicValue !== null ? dynamicValue : value}
          className={`react-select-container ${classes}`}
          classNamePrefix="react-select"
          isSearchable={false}/>
      : <Select 
          components={{ DropdownIndicator }}
          options={options}
          onChange={onChange}
          defaultValue={defaultValue}
          className={`react-select-container ${classes}`}
          classNamePrefix="react-select"
          isSearchable={false}/>
      }
      </>
    )
  }

  return (
    <>
    { isMobileSelect ?
      <select className="mobile-select" onBlur={(e) => onChangeMobile(e)} data-type={type}>
        {options.map((option, i) => {
          let selected = false

          if (dynamicValue !== null && dynamicValue === option.value) {
            selected = true
          }

          return (
            <option key={i} selected={selected} value={option.value}>{option.label}</option>
          )
        })}
      </select>
      :
        renderCustomSelect()
    }
    </>
  )
}

export default CustomSelect